import useSWR from 'swr'
import { fetchInstance } from '../api/instance-api.ts'

/**
 * Read-only and unpolled: what an instance is changes when it is redeployed,
 * and a redeploy replaces this bundle too — so there is nothing for an interval
 * to catch that a reload would not.
 */
export function useInstance() {
  const { data, error, isLoading } = useSWR('/instance', fetchInstance)
  return { instance: data ?? null, error, isLoading }
}
